<template>
  <footer class="container">
    <p>
      By using this site, you accept our
      <a :href="`${identityUrl}/Home/Terms`" target="_blank">Terms of Use</a>
      and
      <a v-if="lenderId === 1023" href="https://www.bcu.org/Legal/Privacy-Policy" target="_blank">Privacy Policy</a>
      <router-link v-else :to="{ name: 'privacyPolicy', query: { lid: lenderId } }" target="_blank">
        Privacy Policy
      </router-link>
    </p>
    <p>© {{ year }} Student Choice. All rights reserved.</p>
  </footer>
</template>

<script setup lang="ts">
import { computed } from "vue";
import { useStore } from "vuex";

interface Props {
  externalLinks: boolean;
  lenderId: number;
}

withDefaults(defineProps<Props>(), {
  externalLinks: false,
  lenderId: 0,
});

const year = computed<number>(() => {
  return new Date().getFullYear();
});
const store = useStore();
const identityUrl = computed(() => store.state.lenderData?.identityUrl);
</script>
<style lang="scss" scoped>
p {
  margin: 0;
}
</style>
